import { Group } from "./_components/group";
import { Tile } from "./_components/tile";

export const ColorTile = {
    Group,
    Tile,
};

export type { GroupProps as ColorTileGroupProps } from "./_components/group";
export type { TileProps as ColorTileProps } from "./_components/tile";
